import { Pagination } from "../utils/pagination"
import { JqElm } from "./ui"

export type PaginationUiOffsetChangeListener = (offset: number) => void

export class PaginationUi {

    private prevBucketElm: JqElm
    private nextBucketElm: JqElm
    private prevPageElm: JqElm
    private nextPageElm: JqElm
    private firstPageElm: JqElm
    private finalPageElm: JqElm 
    public constructor(private paginationElm: JqElm, private pagination: Pagination, private offsetChangeListener: PaginationUiOffsetChangeListener) {
        this.prevBucketElm = paginationElm.find('.pg_prev_bucket').click(e => {
            e.preventDefault()
            this.offsetChangeListener(this.pagination.calculateOffsetByBucketIndex(this.pagination.currentBucketIndex - 1))
        })

        this.nextBucketElm = paginationElm.find('.pg_next_bucket').click(e => {
            e.preventDefault()
            this.offsetChangeListener(this.pagination.calculateOffsetByBucketIndex(this.pagination.currentBucketIndex + 1))
        })
        this.prevPageElm = paginationElm.find('.pg_prev_page').click(e => {
            e.preventDefault()
            this.offsetChangeListener(this.pagination.calculateOffset(this.pagination.currentPageIndex - 1))
        })
        this.nextPageElm = paginationElm.find('.pg_next_page').click(e => {
            e.preventDefault()
            this.offsetChangeListener(this.pagination.calculateOffset(this.pagination.currentPageIndex + 1))
        })
        $(document).on('click', '.pg_item', (e) => {
            e.preventDefault()
            const pageIndex = Number($(e.currentTarget).find('a').text()) - 1
            this.offsetChangeListener(this.pagination.calculateOffset(pageIndex))
        })
        this.firstPageElm = paginationElm.find('.pg_first_page').click(e => {
            e.preventDefault()
            this.offsetChangeListener(0)
        })
        this.finalPageElm = paginationElm.find('.pg_final_page').click(e => {
            e.preventDefault()
            this.offsetChangeListener(this.pagination.calculateOffset(this.pagination.pageCount - 1))
        })

        //this.refresh()
    }

    refresh() {
        if (this.pagination.pageCount < 1) {
            this.paginationElm.hide()
            return
        }
        this.paginationElm.show()
        this.prevBucketElm.toggle(this.pagination.hasPrevBucket)
        this.nextBucketElm.toggle(this.pagination.hasNextBucket)
        this.prevPageElm.toggle(this.pagination.hasPrevPage)
        this.nextPageElm.toggle(this.pagination.hasNextPage)
        this.firstPageElm.toggle(this.pagination.hasPrevPage)
        this.finalPageElm.toggle(this.pagination.hasNextPage)
        this.paginationElm.find('.pg_item').remove()

        let prevElm = this.prevBucketElm
        this.pagination.bucketPages.forEach(pageIdx => {
            console.log("Index:%s", pageIdx)
            const aElm = $('<a href="#"></a>').text(pageIdx + 1)
            const elm = $('<li class="pg_item"></li>').append(aElm).insertAfter(prevElm)
            if (pageIdx == this.pagination.currentPageIndex) {
                elm.addClass('active')
            }
            prevElm = elm
        })
    }

}